import React, { useEffect, useRef, useState, useContext } from 'react'
import TabContentDealerAnalysis from '../Component/DealerAnalysis/TabContentDealerAnalysis';
import { VehicleContext } from '../Component/Context/VehicleContext';
import ModalLayout from '../Component/Common/ModalLayout'
import LoadingModal from '../Component/Common/LoadingModal'

const DealerAnalysis = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const dealership = queryParameters.get("dealership");

    const { getDealershipAnalysis, numberFormatter, getMarketcheckDealers, marketcheckDealers } = useContext(VehicleContext);

    const [dealerAnalysisData, setDealerAnalysisData] = useState({});

    const [loadingPage, setLoadingPage] = useState(false);

    useEffect(() => {
        if(dealership && dealership.trim() != "") getDealershipData();
    }, [dealership]);

    const getDealershipData = async () => {
        setLoadingPage(true);

        const data = await getDealershipAnalysis({ 'dealership': dealership });

        setDealerAnalysisData(data);

        setLoadingPage(false);
    }
    // Find A Dealership

    const [findDealership, setFindDealership] = useState(false);
    const [searchText, setSearchText] = useState("");
    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };
    useEffect(() => {
        setFindDealership(!dealership);
    }, [dealership]);


    // Manage Search options
    const [manageSearchList, setManageSearchList] = useState(false);
    const boxRef = useRef(null);
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setManageSearchList(false);
      }
    };
  
    useEffect(() => {

        getMarketcheckDealers();
        
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    
        
    }, []);
    return (
        <>
            <div className='custom-tabs'>
                <div className='d-flex align-items-end justify-content-between da-main-flex'>
                    <ul className="nav nav-tabs flex-nowrap align-items-start" style={{ width: '100%' }}>
                        <div className='d-flex align-items-center pe-4 nav-tabs-inside' style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap', }}>
                            <li className="nav-item">
                                <button className='nav-link active' style={{ textTransform: 'capitalize' }}>
                                    {dealership}
                                </button>
                            </li>
                        </div>
                    </ul>
                    <div className='da-search-fields mb-2' ref={boxRef}>
                        <div className='position-relative'>
                            <input type='text'
                                className='form-control'
                                placeholder='Search Dealership'
                                value={searchText}
                                onChange={handleSearchChange}
                                onFocus={() => setManageSearchList(true)}
                            />

                        </div>
                        {manageSearchList &&
                            <ul className='fdm-list'>
                                {marketcheckDealers ? (
                                    marketcheckDealers.filter((item) => !searchText || item.seller_name_ss.toLowerCase().includes(searchText.toLowerCase()) || item.location.toLowerCase().includes(searchText.toLowerCase())).map((item, index) => {
                                        if(index > 100) return;

                                        return (
                                            <li key={index}>
                                                <a href={'/dealer-analysis?dealership=' + encodeURIComponent(item.seller_name_ss)} target='_blank' className='d-flex align-items-center justify-content-between'>
                                                    <div className='fd-title text-red'>{item.seller_name_ss}</div>
                                                    <div className='fd-title fw-400'>{item.location}</div>
                                                </a>
                                            </li>
                                        )
                                    })
                                ) : (
                                    <li className="text-muted">No results found</li>
                                )}
                            </ul>
                        }
                    </div>
                </div>
                <div className="tab-content" id="myTabContent">
                    <div className={`tab-pane fade show active`} >
                        <TabContentDealerAnalysis
                            isActive={true}
                            tabId={dealership}
                            dealerAnalysisData={dealerAnalysisData}
                            numberFormatter={numberFormatter}
                        />
                    </div>
                </div>
            </div>
            {!loadingPage && findDealership &&
                <ModalLayout open={findDealership} modalWidth={815} darkThemeCls="true">
                    <div className="modal-content find-dealership-modal p-0">
                        <div className="modal-body p-4">
                            <div className='lb-box'>
                                <div className="sm-title text-start fw-600 text-uppercase mb-2">Find a dealership</div>
                                <div className='d-flex search-flex w-100 mb-4'>
                                    <input type='text' className='form-control' placeholder='Search by Dealership Name or Location' value={searchText} onChange={handleSearchChange} />
                                    <button type='button' className='search-btn'>
                                        Search
                                    </button>
                                </div>
                                <div className='opacity-0-5 xs-title ps-2 mb-2 text-uppercase'>{marketcheckDealers.filter((item) => !searchText || item.seller_name_ss.toLowerCase().includes(searchText.toLowerCase()) || item.location.toLowerCase().includes(searchText.toLowerCase())).length} Results</div>
                                <ul className='fdm-list'>
                                    {marketcheckDealers.length > 0 ? (
                                        marketcheckDealers.filter((item) => !searchText || item.seller_name_ss.toLowerCase().includes(searchText.toLowerCase()) || item.location.toLowerCase().includes(searchText.toLowerCase())).map((item, index) => {
                                            if(index > 100) return;

                                            return (
                                                <li key={index}>
                                                    <a href={'/dealer-analysis?dealership=' + encodeURIComponent(item.seller_name_ss)} className='d-flex align-items-center justify-content-between'>
                                                        <div className='fd-title'>{item.seller_name_ss}</div>
                                                        <div className='fd-title fw-400 opacity-0-7'>{item.location}</div>
                                                    </a>
                                                </li>
                                            )
                                        })
                                    ) : (
                                        <li className="text-muted">No results found</li>
                                    )}
                                </ul>
                            </div>
                        </div>
                    </div>
                </ModalLayout>
            }
            {loadingPage &&
                <ModalLayout open={loadingPage} modalWidth={550} darkThemeCls="true">
                    <LoadingModal />
                </ModalLayout>
            }
        </>
    )
}

export default DealerAnalysis